import { DbCustomerLottery } from "./db-customer-lottery";
import { DbCustomerTasks, DbCustomerFinishedTasks, DbCustomerPrinters, DbCustomerArchivedTasks, DbCustomerLicenses, DbCustomerEvaluations } from "./db-customer-tasks";
import { IDocumentReference, ICollectionReference } from '../database-cast/IDatabase';
import { DbObjectBase } from './db-object-base';
import { Customer } from '../../../core/_shared/models/Customer';


export class DbCustomer extends DbObjectBase<Customer> {



  constructor(id: string, collection: ICollectionReference) {

    super(id, collection);

  }


  getLottery(id: string): DbCustomerLottery {

    let lottery = new DbCustomerLottery(id, this._docReference.collection("lotteries"));

    return lottery;
  }

  public getWaitingTasks(): DbCustomerTasks {

    let tasks = new DbCustomerTasks(this._docReference.collection("tasks/waiting/tasks"));

    return tasks;
  }

  public getFinishedTasks(): DbCustomerFinishedTasks {
      
    let tasks = new DbCustomerFinishedTasks(this._docReference.collection("tasks/finished/tasks"));

    return tasks;
  }

  public getArchivedTasks(): DbCustomerArchivedTasks {
    let tasks = new DbCustomerArchivedTasks(this._docReference.collection("tasks/archived/tasks"));

    return tasks;
  }


  public getProcessingTasks(): DbCustomerFinishedTasks {

    let tasks = new DbCustomerFinishedTasks(this._docReference.collection("tasks/processing/tasks"));

    return tasks;
  }

  getPrinters(): DbCustomerPrinters {
    return new DbCustomerPrinters(this._docReference.collection("printers"));
  }

  getLicenses_deprecated(): DbCustomerLicenses {
    return new DbCustomerLicenses(this._docReference.collection("licenses"));
  }

  getEvaluations(): DbCustomerEvaluations {
    return new DbCustomerEvaluations(this._docReference.collection("evaluations"));
  }


}